import {
  COLLABORATOR_GET_ASYNC,
  CLEAR_COLLABORATORS,
  GUEST_INVITED,
  INVITE_ACCEPTED_ASYNC,
  UPDATE_COLLABORATOR_ASYNC,
  COLLABORATORS_STORIES_GET_ASYNC,
  RESET_COLLABORATOR_ACTION_SUCCESS,
  COLLABORATOR_REMOVED_SUCCESS,
  RESET_INVITE_ACCEPTED,
  SET_PENDING_INVITE,
  CLEAR_PENDING_INVITE,
} from './action-types';

const initialState = {
  guest: false,
  type: '',
  collaborators: [],
  collaboratorsStories: [],
  roleUser: '',
  actionSuccessColab: false,
  collabRemoved: false,
  inviteflag: false,
  inviteData: null,
};

const collaborator = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case GUEST_INVITED:
      return { ...state, guest: true, type: payload };
    case INVITE_ACCEPTED_ASYNC:
      return { ...state, roleUser: payload, inviteflag: true };
    case RESET_INVITE_ACCEPTED:
      return { ...state, inviteflag: false };
    case COLLABORATOR_GET_ASYNC:
      return { ...state, actionSuccessColab: true, collaborators: payload };
    case COLLABORATORS_STORIES_GET_ASYNC:
      return { ...state, actionSuccessColab: true, collaboratorsStories: payload };
    case UPDATE_COLLABORATOR_ASYNC:
      if (!Array.isArray(state.collaborators)) {
        return state;
      }
      const updatedCollaborators = payload.updatedCollaborators || [];
      return {
        ...state,
        actionSuccessColab: true,
        collaborators: state.collaborators.map((colab: any) =>
          updatedCollaborators.find((updated: any) => updated.id === colab.id)
            ? { ...colab, ...updatedCollaborators.find((updated: any) => updated.id === colab.id) }
            : colab
        ),
      };
    case COLLABORATOR_REMOVED_SUCCESS:
      return { ...state, collabRemoved: true };
    case RESET_COLLABORATOR_ACTION_SUCCESS:
      return { ...state, actionSuccessColab: false, collabRemoved: false };
    case CLEAR_COLLABORATORS:
      return { ...initialState };
    case SET_PENDING_INVITE:
      return { ...state, inviteData: payload };
    case CLEAR_PENDING_INVITE:
      return { ...state, inviteData: null };
    default:
      return state;
  }
};

export default collaborator;
